/* eslint-disable camelcase */
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '../components/common/Modal/Modal';
import CrosstabViewerGrid from '../components/crosstab/CrosstabViewerGrid/CrosstabViewerGrid';
import CrosstabViewerGridBodyCell from '../components/crosstab/CrosstabViewerGrid/CrosstabViewerGridBodyCell';
import Highlight from '../components/common/HighlightAndFilter/Highlight';
import QuadChartViewer from '../components/crosstab/QuadChartViewer';
import * as CrosstabUtils from '../util/CrosstabUtils';
import { sendVPVHotjarEvent } from '../util/hotjarUtils';
import TrendGraphView from '../components/crosstab/Trend/TrendGraphView';
import * as messages from '../messages/ReportsMessages';
import * as crosstabActions from '../actions/crosstabActions';
import PrivateEyeView from '../components/common/EnhancedGrid/PrivateEyeViewV2';
import CrosstabView from '../components/common/EnhancedGrid/CrosstabViewV2';
import {
  CROSSTAB_SAVE_PLACEHOLDER_LABEL,
  CROSSTAB_SAVE_WARNING_TEXT,
} from '../constants';
import {
  CROSSTAB_CLEAR_SINGLE_ITEM,
  CROSSTAB_SORT,
  CROSSTAB_ITEM_RESTORE,
  CROSSTAB_CELL_HIGHLIGHT_FILTERING_OPEN,
} from '../trackerConstants';
import {
  HJ_CROSSTAB_CLEAR_SINGLE_ITEM,
  HJ_CROSSTAB_SORT,
  HJ_CROSSTAB_ITEM_RESTORE,
} from '../hotjarConstants';
import { saveTrackingData } from '../util/trackerUtils';

const ModalQuadChartorHnFStyle = {
  minWidth: '850px',
  width: '60%',
  height: 'auto',
  left: '23%',
  top: '1%',
};

const defaultColumnHeaderDef = {
  label: '',
  name: '',
  sortOrder: CrosstabUtils.SORT_DIRECTION.NONE,
  sortKey: '',
};

class CrosstabViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      horizontalEPP: 15,
      verticalEPP: Math.round((window.innerHeight - 360) / 40),
      horizontalPageNo: 0,
      verticalPageNo: 0,
      horizontalTotalPages: 1,
      verticalTotalPages: 1,
      ctbTitle: '',
      labelCtbTitle: '',
      crosstabTableList: [],
      columnDefinitions: [],
      activeCrosstabTable: {},
      // selectedExportOption: 'excel2007',
      // checkBoxes: {
      //   sample: true,
      //   weighted: true,
      //   vertical: true,
      //   horizontal: true,
      //   index: true,
      // },
      selectedRadioButton: 'graphView',
      flagSpinner: false,
      selectedBaseNodeDetails: this.props.selectedBase,
      selectedBase: this.props.selectedBase,
      privateEyeGridTitle: '',
      crosstabGridTitle: '',
      sortClickToggle: false,
    };
    this.crosstabViewerGrid = React.createRef();
    this.newCrosstabViewerGrid = React.createRef();
    this.newPrivateEyeViewerGrid = React.createRef();
  }

  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.gridResize);
    if (
      this.props &&
      this.props.crosstabTableList &&
      this.props.crosstabTableList.length > 0
    ) {
      const activeCrosstabTable = this.props.crosstabTableList.filter(
        crosstabTable => crosstabTable.isActive
      )[0];
      const defaultVisibleCellElement = this.props.cellElementList.filter(
        ({ isVisible }) => isVisible
      );
      const horizontalFactor =
        Math.ceil(this.state.horizontalEPP / defaultVisibleCellElement.length) -
        2;
      this.setState(
        {
          verticalTotalPages:
            this.props.crosstabRows &&
            this.props.crosstabRows.length > this.state.verticalEPP - 2
              ? this.props.crosstabRows.length - (this.state.verticalEPP - 2)
              : 1,
          horizontalTotalPages:
            this.props.crosstabColumns &&
            this.props.crosstabColumns.length > horizontalFactor
              ? this.props.crosstabColumns.length - (horizontalFactor - 1)
              : 1,
          crosstabTableList: this.props.crosstabTableList,
          columnDefinitions: activeCrosstabTable.columnHeaderList.map(
            columnHeader => ({
              ...defaultColumnHeaderDef,
              ...columnHeader,
            })
          ),
          activeCrosstabTable,
        },
        () => {
          if (
            this.state.activeCrosstabTable.viewerGridType ===
            CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.CROSSTAB
          ) {
            this.setState({
              verticalEPP: Math.round((window.innerHeight - 360) / 141),
              verticalTotalPages:
                this.props.crosstabRows &&
                this.props.crosstabRows.length > this.state.verticalEPP - 2
                  ? this.props.crosstabRows.length -
                    (this.state.verticalEPP - 2)
                  : 1,
            });
          }
        }
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.crosstabTableList !== nextProps.crosstabTableList) {
      if (
        nextProps.crosstabTableList &&
        nextProps.crosstabTableList.length > 0
      ) {
        if (
          !_.isEqual(
            nextProps.crosstabTableList[0].crosstabPerStudy,
            this.props.crosstabTableList[0].crosstabPerStudy
          )
        ) {
          this.setState(prevState => ({
            selectedBaseNodeDetails: prevState.selectedBase,
          }));
        }
        // this.controls.resetControls();
        let activeCrosstabTable = nextProps.crosstabTableList.filter(
          crosstabTable => crosstabTable.isActive
        )[0];
        if (this.state.activeCrosstabTable === activeCrosstabTable) {
          // InActive entry deleted
          this.setState({ crosstabTableList: nextProps.crosstabTableList });
        } else {
          if (
            activeCrosstabTable.sortOrder &&
            activeCrosstabTable.sortOrder !== CrosstabUtils.SORT_DIRECTION.NONE
          ) {
            activeCrosstabTable = CrosstabUtils.sortCrosstabTable(
              activeCrosstabTable,
              this.props.crosstabWeightTypes
            );
          }
          this.setState(
            {
              crosstabTableList: nextProps.crosstabTableList,
              columnDefinitions: activeCrosstabTable.columnHeaderList.map(
                columnHeader => ({
                  ...defaultColumnHeaderDef,
                  ...columnHeader,
                })
              ),
              activeCrosstabTable,
            },
            () => {
              if (
                this.state.activeCrosstabTable.viewerGridType ===
                CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.CROSSTAB
              ) {
                this.setState(prevState => ({
                  verticalEPP: Math.round((window.innerHeight - 360) / 141),
                  verticalTotalPages:
                    this.props.crosstabRows &&
                    this.props.crosstabRows.length > prevState.verticalEPP - 2
                      ? this.props.crosstabRows.length -
                        (prevState.verticalEPP - 2)
                      : 1,
                }));
              }
              this.setState(prevState => ({
                verticalEPP:
                  prevState.activeCrosstabTable.viewerGridType ===
                  CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND
                    ? Math.round((window.innerHeight - 360) / 85)
                    : Math.round((window.innerHeight - 360) / 40),
              }));
            }
          );
        }
        const defaultVisibleCellElement = this.props.cellElementList.filter(
          ({ isVisible }) => isVisible
        );
        const horizontalFactor =
          Math.ceil(
            this.state.horizontalEPP / defaultVisibleCellElement.length
          ) - 2;
        this.setState(prevState => ({
          verticalTotalPages:
            this.props.crosstabRows &&
            this.props.crosstabRows.length > prevState.verticalEPP - 2
              ? this.props.crosstabRows.length - (prevState.verticalEPP - 2)
              : 1,
          horizontalTotalPages:
            this.props.crosstabColumns &&
            this.props.crosstabColumns.length > horizontalFactor
              ? this.props.crosstabColumns.length - (horizontalFactor - 1)
              : 1,
          verticalPageNo: 0,
          crosstabTableList: nextProps.crosstabTableList,
        }));
      } else {
        this.setState({
          crosstabTableList: [],
          activeCrosstabTable: {},
        });
      }
    }

    if (this.props.cellElementList !== nextProps.cellElementList) {
      const horizontalFactor = 1;
      const horizontalTotalPages =
        this.props.crosstabColumns &&
        this.props.crosstabColumns.length > horizontalFactor
          ? this.props.crosstabColumns.length - (horizontalFactor - 1)
          : 1;
      this.setState(prevState => ({
        verticalEPP: Math.round((window.innerHeight - 360) / 40),
        horizontalTotalPages,
        horizontalPageNo:
          prevState.horizontalPageNo < horizontalTotalPages - 1
            ? prevState.horizontalPageNo
            : horizontalTotalPages - 1,
      }));
    }

    if (
      this.state.activeCrosstabTable.viewerGridType ===
      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND
    ) {
      this.setState(prevState => ({
        verticalEPP: Math.round((window.innerHeight - 360) / 85),
        verticalTotalPages:
          this.props.crosstabRows &&
          this.props.crosstabRows.length > prevState.verticalEPP - 2
            ? this.props.crosstabRows.length - (prevState.verticalEPP - 2)
            : 1,
      }));
    } else if (
      this.state.activeCrosstabTable.viewerGridType ===
      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.CROSSTAB
    ) {
      this.setState(prevState => ({
        verticalEPP: Math.round((window.innerHeight - 360) / 141),
        verticalTotalPages: prevState.verticalTotalPages,
      }));
    } else {
      this.setState({
        verticalEPP: Math.round((window.innerHeight - 360) / 40),
      });
    }

    if (!_.isEqual(this.props.selectedBase, nextProps.selectedBase)) {
      let baseDataExistsFlag = false;
      const selectedBaseName = this.selectedBaseNode(nextProps.selectedBase);
      nextProps.crosstabTableList[0].crosstabPerStudy[0].forEach(elems => {
        if (
          elems.idKey === selectedBaseName ||
          elems.filter === selectedBaseName
        ) {
          baseDataExistsFlag = true;
        }
      });
      if (baseDataExistsFlag) {
        this.setState({
          selectedBase: nextProps.selectedBase,
          selectedBaseNodeDetails: nextProps.selectedBase,
        });
      } else {
        this.setState({ selectedBase: nextProps.selectedBase });
      }
    }
  }

  getCrosstabTitle = () => {
    if (this.crosstabViewerGrid && this.crosstabViewerGrid.current) {
      return this.crosstabViewerGrid.current.getCrosstabTitle();
    }
    if (
      this.state.activeCrosstabTable.viewerGridType === 'Private Eye' ||
      this.state.activeCrosstabTable.viewerGridType === 'Private Eye View'
    ) {
      return this.state.privateEyeGridTitle;
    }
    if (
      this.state.activeCrosstabTable.viewerGridType === 'Crosstab' ||
      this.state.activeCrosstabTable.viewerGridType === 'Crosstab View'
    ) {
      return this.state.crosstabGridTitle;
    }
    if (
      this.state.activeCrosstabTable.viewerGridType ===
      CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.QUADCHART
    ) {
      return this.props.loadedCrosstabInfo.tableTitle;
    }
    return 'TREND';
  };

  setVerticalPage = value =>
    this.setState(() => ({ verticalPageNo: value - 1 }));

  setHorizontalPage = value =>
    this.setState(() => ({ horizontalPageNo: value - 1 }));

  clearData = () => {
    this.props.crosstabActions.clearSampleWeighted('ColumnsDataGrid');
    this.props.crosstabActions.clearSampleWeighted('RowsDataGrid');
    this.props.crosstabActions.clearSampleWeighted('BasesDataGrid');
    this.props.crosstabActions.clearSampleWeighted('ScratchDataGrid');
    this.props.crosstabActions.deleteCrosstabGrid();
    this.props.resetSmarchSearch();
    // this.props.studyActions.setTrendStudies([]);
  };

  handleColumnDropdown = selectedDropdownColumn =>
    this.props.crosstabActions.updateCrosstabGrid(
      this.state.activeCrosstabTable.idKey,
      { selectedDropdownColumn }
    );

  handleHighlightAndFilter = highlightAndFilter =>
    this.props.crosstabActions.updateCrosstabGrid(
      this.state.activeCrosstabTable.idKey,
      { highlightAndFilter }
    );

  handleConditionalFiltering = conditionalFormatting =>
    this.props.crosstabActions.updateCrosstabGrid(
      this.state.activeCrosstabTable.idKey,
      { conditionalFormatting }
    );

  handleSort = (sortOrder, sortKey, sortColumnIndex) => {
    this.props.crosstabActions.updateCrosstabGrid(
      this.state.activeCrosstabTable.idKey,
      {
        sortOrder,
        sortKey,
        sortColumnIndex,
      }
    );
    this.setState({ sortClickToggle: !this.state.sortClickToggle });
    if (sortOrder !== 'none') {
      this.props.trackerFn({
        action: CROSSTAB_SORT,
        attributes: {
          sortOrder: sortOrder.toUpperCase(),
          sortKey: sortKey.toUpperCase(),
        },
      });
      sendVPVHotjarEvent(HJ_CROSSTAB_SORT);
    }
  };

  handleCrosstabSaveButton = ctbTitle => {
    this.setState(
      () => ({ ctbTitle, labelCtbTitle: ctbTitle }),
      () => {
        this.props.handleSaveCrosstab();
      }
    );
  };

  callbackSpinnerControl = flagSpinner => {
    this.setState({ flagSpinner });
  };

  handleRadioOptions = selectedOption => {
    this.handleConditionalFiltering(selectedOption ? 'HNF' : 'DefaultFilter');
    // this.handleConditionalFiltering('');
    // NADO - 3314 (slide 11)
    if (!selectedOption) {
      this.handleHighlightAndFilter({
        sample: { highlight: [], filter: [] },
        weighted: { highlight: [], filter: [] },
        vertical: { highlight: [], filter: [] },
        horizontal: { highlight: [], filter: [] },
        index: { highlight: [], filter: [] },
      });
    }
  };

  handleRadioButtonChange = e => {
    this.setState({
      selectedRadioButton: e.currentTarget.value,
    });
  };

  handleHighlightShowButton = () => {
    this.highlightModal.show();
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo: this.props.crosstabStudy.pn,
      moduleName: 'crosstab',
      action: CROSSTAB_CELL_HIGHLIGHT_FILTERING_OPEN,
    });
  };

  filterStandardBase = selectedBaseNode => {
    const selectedStandardBaseArray = this.props.standardBaseLists.filter(
      elment => elment.expression === selectedBaseNode
    );
    const standardBase =
      selectedStandardBaseArray[0] && selectedStandardBaseArray[0].label
        ? selectedStandardBaseArray[0].label.toUpperCase()
        : 'StudyUniverseKey';

    return standardBase;
  };

  selectedBaseNode = selectedBaseNodeDetails => {
    const selectedBaseNode =
      selectedBaseNodeDetails.selectedBaseGroup === 'standard-base'
        ? this.filterStandardBase(selectedBaseNodeDetails.selectedBaseNode)
        : selectedBaseNodeDetails.selectedBase;
    return selectedBaseNode;
  };

  singleDeleteOperation = (gridType, type, elemIndex) => {
    let updatedGridData;
    this.props.trackerFn({
      action: CROSSTAB_CLEAR_SINGLE_ITEM,
      attributes: { gridType: type === 'row' ? 'ROW' : 'COLUMN' },
    });
    sendVPVHotjarEvent(HJ_CROSSTAB_CLEAR_SINGLE_ITEM);
    if (type === 'row') {
      updatedGridData = this.props.crosstabRows
        ? _.cloneDeep(this.props.crosstabRows)
        : [];
      updatedGridData.splice(elemIndex - 1, 1);
    } else {
      updatedGridData = this.props.crosstabColumns
        ? _.cloneDeep(this.props.crosstabColumns)
        : [];
      updatedGridData.splice(elemIndex - 1, 1);
    }
    const {
      updatedCrosstabTableList,
      updatedCrosstabRequestData,
      updatedCrosstabPayload,
    } = CrosstabUtils.singleDeleteOperation(
      gridType,
      type,
      elemIndex,
      this.props.crosstabTableList,
      this.props.crosstabRequestData,
      this.props.crosstabPayload
    );
    this.props.crosstabActions.toggleCrosstabGridData(
      gridType,
      updatedCrosstabTableList,
      updatedGridData,
      updatedCrosstabRequestData,
      updatedCrosstabPayload
    );
  };

  getTableHeight = () => {
    const maxHeight = document.body.clientHeight - 220;
    return `${maxHeight}px`;
  };

  gridResize = () => {
    const maxHeight = document.body.clientHeight - 220;
    $('.crosstab-viewer-main-wrapper').css({ 'max-height': maxHeight });
  };

  updateCrosstabGridTitleHeader = updatedData => {
    let gridCategory = '';
    let originalList = [];
    switch (updatedData.gridCategory) {
      case 'ColumnsDataGrid':
        gridCategory = 'column';
        break;
      case 'RowsDataGrid':
        gridCategory = 'row';
        break;
      default:
        gridCategory = '';
    }
    if (gridCategory !== '' && gridCategory === 'column') {
      originalList = this.props.crosstabColumns;
    } else {
      originalList = this.props.crosstabRows;
    }
    const index = updatedData.index - 1;
    updatedData.index = index;
    updatedData.keyword = originalList[index].keyword;
    const dataSmartSearch = originalList[index].dataSmartSearch;
    const oldLabel = CrosstabUtils.filterLabel(
      `${dataSmartSearch.objectsAdded[0].shortTextCatgView}`,
      `${dataSmartSearch.objectsAdded[0].breadcrumbs}`
    );
    const isLabelUpdated = !(oldLabel === updatedData.updatedTitle);
    updatedData = {
      ...updatedData,
      isLabelUpdated,
    };
    this.props.crosstabActions.updateCrosstabGridTitleHeader(updatedData);
  };

  updateGridData = (updatedObjectProps, gridType, index) => {
    let gridCategory = '';
    let currentObject = {};
    let originalList = [];
    switch (gridType) {
      case 'ColumnsDataGrid':
        gridCategory = 'column';
        break;
      case 'RowsDataGrid':
        gridCategory = 'row';
        break;
      default:
        gridCategory = '';
    }
    if (gridCategory !== '' && gridCategory === 'column') {
      originalList = this.props.crosstabColumns;
    } else {
      originalList = this.props.crosstabRows;
    }
    const indexVal = index - 1;
    currentObject = _.cloneDeep(originalList[indexVal]);
    const dataSmartSearch = currentObject.dataSmartSearch;
    const oldLabel = CrosstabUtils.filterLabel(
      `${dataSmartSearch.objectsAdded[0].shortTextCatgView}`,
      `${dataSmartSearch.objectsAdded[0].breadcrumbs}`
    );
    const isLabelUpdated = !(oldLabel === updatedObjectProps.title);
    const updatedObject = {
      ...currentObject,
      ...updatedObjectProps,
      isLabelUpdated,
    };

    updatedObject.dataSmartSearch.autocodenode.labelOverride =
      updatedObjectProps.title;
    updatedObject.dataSmartSearch.autocodenode.useLabelOverride = isLabelUpdated;

    this.props.crosstabActions.updateSampleWeighted(
      originalList.reduce((acc, currentValue) => {
        if (currentValue.id === updatedObject.id) {
          acc.push({
            ...currentValue,
            ...updatedObject,
          });
        } else {
          acc.push(currentValue);
        }
        return acc;
      }, []),
      gridType
    );
  };

  restoreGridTitle = (index, gridType) => {
    this.props.crosstabActions.restoreGridTitle(index - 1, gridType);
    this.props.trackerFn({
      action: CROSSTAB_ITEM_RESTORE,
      attributes: { gridType: gridType === 'RowsDataGrid' ? 'ROW' : 'COLUMN' },
    });
    sendVPVHotjarEvent(HJ_CROSSTAB_ITEM_RESTORE);
  };

  renderQuadChartView = () => {
    return (
      <div>
        <p className="quad-info-text">
          Create a box with your mouse to zoom in on the data points.
        </p>
        <div className="row expanded crosstab-viewer-quad-wrapper">
          <div className="quadChart-ct-header">
            <span>Quad Chart Viewer</span>
          </div>
          <QuadChartViewer
            study={
              this.state.activeCrosstabTable.studyInfo
                ? this.state.activeCrosstabTable.studyInfo.sd
                : ''
            }
            weightType={
              this.props.crosstabWeightTypes
                ? this.props.crosstabWeightTypes
                : this.props.crosstabStudy.cw[0]
            }
          />
        </div>
      </div>
    );
  };

  getGridRows = () => {
    const { crosstabPerStudy } = this.state.activeCrosstabTable;
    const selectedBaseID = this.selectedBaseNode(
      this.state.selectedBaseNodeDetails
    );
    const { selectedBaseGroup } = this.props.selectedBase;
    const selectedBaseIndex = this.props.crosstabTableList[0].selectedBase;

    let newRowsList = crosstabPerStudy[0][selectedBaseIndex];
    if (selectedBaseGroup === 'user-defined') {
      if (!_.isEmpty(crosstabPerStudy[0])) {
        crosstabPerStudy[0].forEach((keys, index) => {
          if (keys.idKey === selectedBaseID || keys.filter === selectedBaseID) {
            newRowsList = crosstabPerStudy[0][index];
          }
        });
      }
      if (_.isEmpty(newRowsList)) {
        newRowsList = crosstabPerStudy[0][0];
      }
    } else if (!_.isEmpty(crosstabPerStudy[0])) {
      crosstabPerStudy[0].forEach((keys, index) => {
        if (keys.idKey === selectedBaseID || keys.filter === selectedBaseID) {
          newRowsList = crosstabPerStudy[0][index];
        }
      });
    }
    return newRowsList ? newRowsList.rowList : crosstabPerStudy[0][0].rowList;
  };

  saveGridTitle = (text, gridName) => {
    if (gridName === 'Crosstab-View') {
      this.setState({ crosstabGridTitle: text });
    } else if (gridName === 'PrivateEye-View') {
      this.setState({ privateEyeGridTitle: text });
    }
  };

  render() {
    return (
      <div
        className="crosstab-viewer-main-wrapper"
        style={{ maxHeight: this.getTableHeight(), overflow: 'auto' }}
      >
        {this.state.activeCrosstabTable.viewerGridType === 'Quad' ? (
          this.renderQuadChartView()
        ) : (
          <div className="quick-report-radio crosstab-new-radio-p">
            {this.state.activeCrosstabTable.viewerGridType ===
              CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND &&
            this.props.trendStudies &&
            this.props.trendStudies.length > 0 ? (
              <div className="crosstab-align-tab">
                <p>
                  <input
                    type="radio"
                    id="graphView"
                    name="ChartType"
                    value="graphView"
                    checked={this.state.selectedRadioButton === 'graphView'}
                    onChange={this.handleRadioButtonChange}
                  />
                  <label htmlFor="graphView">
                    <span>Graph View</span>
                  </label>
                </p>
                <p>
                  <input
                    type="radio"
                    id="dataView"
                    name="ChartType"
                    value="dataView"
                    checked={this.state.selectedRadioButton === 'dataView'}
                    onChange={this.handleRadioButtonChange}
                  />
                  <label htmlFor="dataView">
                    <span>Data View</span>
                  </label>
                </p>
              </div>
            ) : null}
            <div>
              {this.state.activeCrosstabTable.viewerGridType ===
                CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND &&
              this.state.selectedRadioButton === 'graphView' &&
              this.props.trendStudies &&
              this.props.trendStudies.length > 0 ? (
                <div>
                  <TrendGraphView
                    cellElementList={this.props.cellElementList}
                  />
                </div>
              ) : (
                <div>
                  <div className="row expanded">
                    <div className="columns large-12 crosstab-viewer-child-wrapper-left">
                      <div className="row expanded top-controls-wrapper">
                        <div className="columns large-12 padding-left-0 padding-right-0">
                          {this.state.activeCrosstabTable.viewerGridType ===
                            CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE.TREND &&
                            this.props.trendStudies &&
                            this.props.trendStudies.length > 0 && (
                              <div className="row expanded">
                                <div className="columns large-12 padding-left-0 padding-right-0">
                                  <CrosstabViewerGrid
                                    ref={this.crosstabViewerGrid}
                                    verticalPageNo={this.state.verticalPageNo}
                                    verticalEPP={this.state.verticalEPP}
                                    verticalTotalPages={
                                      this.state.verticalTotalPages
                                    }
                                    horizontalPageNo={
                                      this.state.horizontalPageNo
                                    }
                                    horizontalEPP={this.state.horizontalEPP}
                                    horizontalTotalPages={
                                      this.state.horizontalTotalPages
                                    }
                                    setVerticalPage={this.setVerticalPage}
                                    setHorizontalPage={this.setHorizontalPage}
                                    viewerGridType={
                                      this.state.activeCrosstabTable
                                        .viewerGridType
                                    }
                                    renderBodyCell={CrosstabViewerGridBodyCell}
                                    columnDefinitions={
                                      this.state.columnDefinitions
                                    }
                                    cellElementList={this.props.cellElementList}
                                    tableData={this.state.activeCrosstabTable}
                                    handleColumnDropdown={
                                      this.handleColumnDropdown
                                    }
                                    handleCrosstabSaveButton={
                                      this.handleCrosstabSaveButton
                                    }
                                    clearData={this.clearData}
                                    highlightModal={this.highlightModal}
                                    highlightRadioButton={
                                      this.handleRadioOptions
                                    }
                                    stopSpinner={this.props.stopSpinner}
                                    onSort={(
                                      sortOrder,
                                      sortKey,
                                      sortColumnIndex
                                    ) =>
                                      this.handleSort(
                                        sortOrder,
                                        sortKey,
                                        sortColumnIndex
                                      )
                                    }
                                    selectedBaseIndex={
                                      this.props.crosstabTableList[0]
                                        .selectedBase
                                    }
                                    selectedBaseID={this.selectedBaseNode(
                                      this.state.selectedBaseNodeDetails
                                    )}
                                    crosstabFootNotes={
                                      this.props.crosstabFootNotes
                                    }
                                  />
                                </div>
                              </div>
                            )}
                          {(this.state.activeCrosstabTable.viewerGridType ===
                            'Private Eye View' || this.state.activeCrosstabTable.viewerGridType ===
                            'Private Eye') && (
                            <div className="row expanded custom-crosstab-table">
                              <div className="columns large-12 padding-left-0 padding-right-0">
                                <PrivateEyeView
                                  ref={this.newPrivateEyeViewerGrid}
                                  tableData={this.state.activeCrosstabTable}
                                  handleCrosstabSaveButton={
                                    this.handleCrosstabSaveButton
                                  }
                                  highlightRadioButton={this.handleRadioOptions}
                                  cellElementList={this.props.cellElementList}
                                  onSort={this.handleSort}
                                  handleHighlightShowButton={
                                    this.handleHighlightShowButton
                                  }
                                  placeholder={CROSSTAB_SAVE_PLACEHOLDER_LABEL}
                                  warningText={CROSSTAB_SAVE_WARNING_TEXT}
                                  toggleCheckVal={this.props.toggleCheckVal}
                                  singleDeleteOperation={
                                    this.singleDeleteOperation
                                  }
                                  updateCrosstabGridTitleHeader={
                                    this.updateCrosstabGridTitleHeader
                                  }
                                  updateGridData={this.updateGridData}
                                  restoreGridTitle={this.restoreGridTitle}
                                  handleCrosstabEdit={
                                    this.props.handleCrosstabEdit
                                  }
                                  crosstabFootNotes={
                                    this.props.crosstabFootNotes
                                  }
                                  getGridRows={this.getGridRows()}
                                  saveGridTitle={this.saveGridTitle}
                                  editExpression={this.props.editExpression}
                                  sortClickToggle={this.state.sortClickToggle}
                                  partsToShow={this.props.partsToShow}
                                  handleProbabilitiesEditClick={
                                    this.props.handleProbabilitiesEditClick
                                  }
                                />
                              </div>
                            </div>
                          )}
                          {(this.state.activeCrosstabTable.viewerGridType ===
                            'Crosstab View' || this.state.activeCrosstabTable.viewerGridType ===
                            'Crosstab') && (
                            <div className="row expanded custom-crosstab-table">
                              <div className="columns large-12 padding-left-0 padding-right-0">
                                <CrosstabView
                                  ref={this.newCrosstabViewerGrid}
                                  tableData={this.state.activeCrosstabTable}
                                  handleCrosstabSaveButton={
                                    this.handleCrosstabSaveButton
                                  }
                                  highlightRadioButton={this.handleRadioOptions}
                                  cellElementList={this.props.cellElementList}
                                  onSort={this.handleSort}
                                  handleHighlightShowButton={
                                    this.handleHighlightShowButton
                                  }
                                  placeholder={CROSSTAB_SAVE_PLACEHOLDER_LABEL}
                                  warningText={CROSSTAB_SAVE_WARNING_TEXT}
                                  toggleCheckVal={this.props.toggleCheckVal}
                                  crosstabWeightTypes={
                                    this.props.crosstabWeightTypes
                                  }
                                  singleDeleteOperation={
                                    this.singleDeleteOperation
                                  }
                                  updateCrosstabGridTitleHeader={
                                    this.updateCrosstabGridTitleHeader
                                  }
                                  updateGridData={this.updateGridData}
                                  restoreGridTitle={this.restoreGridTitle}
                                  handleCrosstabEdit={
                                    this.props.handleCrosstabEdit
                                  }
                                  crosstabFootNotes={
                                    this.props.crosstabFootNotes
                                  }
                                  getGridRows={this.getGridRows()}
                                  saveGridTitle={this.saveGridTitle}
                                  editExpression={this.props.editExpression}
                                  sortClickToggle={this.state.sortClickToggle}
                                  partsToShow={this.props.partsToShow}
                                  handleProbabilitiesEditClick={
                                    this.props.handleProbabilitiesEditClick
                                  }
                                />
                              </div>
                            </div>
                          )}
                          <div className="margin-top-15">
                            <div className="row expanded text-right font-8">
                              {this.state.activeCrosstabTable &&
                              this.state.activeCrosstabTable.isLabelUpdated &&
                              this.state.activeCrosstabTable.viewerGridType !==
                                CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE
                                  .TREND ? (
                                <div>
                                  <small className="font-8">
                                    <sup>1</sup> Label changed by user
                                  </small>
                                </div>
                              ) : (
                                ''
                              )}
                              {this.state.activeCrosstabTable &&
                              this.state.activeCrosstabTable.isNADataPresent &&
                              this.state.activeCrosstabTable.viewerGridType !==
                                CrosstabUtils.CROSSTAB_VIEWER_GRID_TYPE
                                  .TREND ? (
                                <div>
                                  <small className="font-8">
                                    N/A Data selected is not available in one or
                                    more selected geographies
                                  </small>
                                </div>
                              ) : (
                                ''
                              )}
                            </div>
                            <div className="row expanded text-right font-8">
                              <small className="font-8">
                                {this.state.activeCrosstabTable &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ] &&
                                (this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ].isCondition1 ||
                                  this.state.activeCrosstabTable
                                    .crosstabPerStudy[0][
                                    this.state.activeCrosstabTable.selectedBase
                                  ].isCondition2)
                                  ? messages.CELL_COUNT_31_60
                                  : ''}
                              </small>
                            </div>
                            <div className="row expanded text-right font-8">
                              <small className="font-8">
                                {this.state.activeCrosstabTable &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ] &&
                                (this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ].isCondition1 ||
                                  this.state.activeCrosstabTable
                                    .crosstabPerStudy[0][
                                    this.state.activeCrosstabTable.selectedBase
                                  ].isCondition2)
                                  ? messages.CELL_COUNT_BELOW_31
                                  : ''}
                              </small>
                            </div>
                            <div className="row expanded text-right font-8">
                              <small className="font-8">
                                {this.state.activeCrosstabTable &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ] &&
                                (this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ].isMRICondition1 ||
                                  this.state.activeCrosstabTable
                                    .crosstabPerStudy[0][
                                    this.state.activeCrosstabTable.selectedBase
                                  ].isMRICondition1)
                                  ? messages.MRI_CELL_COUNT_BELOW_50
                                  : ''}
                              </small>
                            </div>
                            <div className="row expanded text-right font-8">
                              <small className="font-8">
                                {this.state.activeCrosstabTable &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ] &&
                                (this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ].isMRICondition2 ||
                                  this.state.activeCrosstabTable
                                    .crosstabPerStudy[0][
                                    this.state.activeCrosstabTable.selectedBase
                                  ].isMRICondition2)
                                  ? messages.MRI_CELL_COUNT_BELOW_25
                                  : ''}
                              </small>
                            </div>
                            <div className="row expanded text-right font-8">
                              <small className="font-8">
                                {this.state.activeCrosstabTable &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ] &&
                                (this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ].isMRICondition3 ||
                                  this.state.activeCrosstabTable
                                    .crosstabPerStudy[0][
                                    this.state.activeCrosstabTable.selectedBase
                                  ].isMRICondition3)
                                  ? messages.MRI_CELL_COUNT_25_49
                                  : ''}
                              </small>
                            </div>
                            <div className="row expanded text-right font-8">
                              <small className="font-8">
                                {this.state.activeCrosstabTable &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ] &&
                                (this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ].isMRICondition4 ||
                                  this.state.activeCrosstabTable
                                    .crosstabPerStudy[0][
                                    this.state.activeCrosstabTable.selectedBase
                                  ].isMRICondition4)
                                  ? messages.MRI_CELL_COUNT_BELOW_31
                                  : ''}
                              </small>
                            </div>
                            <div className="row expanded text-right font-8">
                              <small className="font-8">
                                {this.state.activeCrosstabTable &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy &&
                                this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ] &&
                                (this.state.activeCrosstabTable
                                  .crosstabPerStudy[0][
                                  this.state.activeCrosstabTable.selectedBase
                                ].isMRICondition5 ||
                                  this.state.activeCrosstabTable
                                    .crosstabPerStudy[0][
                                    this.state.activeCrosstabTable.selectedBase
                                  ].isMRICondition5)
                                  ? messages.MRI_CELL_COUNT_31_59
                                  : ''}
                              </small>
                            </div>
                          </div>
                        </div>
                        <Modal
                          title="Cell Highlighting and Filtering"
                          ref={node => (this.highlightModal = node)}
                          dialogStyles={ModalQuadChartorHnFStyle}
                        >
                          <Highlight
                            tableData={this.state.activeCrosstabTable}
                            handleHighlightAndFilter={
                              this.handleHighlightAndFilter
                            }
                            handleConditionalFiltering={
                              this.handleConditionalFiltering
                            }
                            handleParentHide={() => this.highlightModal.hide()}
                            handleRadioOptions={this.handleRadioOptions}
                          />
                        </Modal>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
CrosstabViewer.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId: PropTypes.number,
  trendStudies: PropTypes.arrayOf(PropTypes.object),
  crosstabColumns: PropTypes.arrayOf(PropTypes.object),
  crosstabRows: PropTypes.arrayOf(PropTypes.object),
  crosstabActions: PropTypes.shape({
    updateCrosstabGrid: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
    deleteCrosstabGrid: PropTypes.func,
    restoreGridTitle: PropTypes.func,
    updateSampleWeighted: PropTypes.func,
    updateCrosstabGridTitleHeader: PropTypes.func,
    toggleCrosstabGridData: PropTypes.func,
  }),
  crosstabStudy: PropTypes.shape({
    pn: PropTypes.number,
    cw: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  resetSmarchSearch: PropTypes.func,
  stopSpinner: PropTypes.func,
  crosstabTableList: PropTypes.arrayOf(PropTypes.object),
  cellElementList: PropTypes.arrayOf(PropTypes.shape({})),
  loadedCrosstabInfo: PropTypes.shape({
    tableTitle: PropTypes.string,
  }),
  selectedBase: PropTypes.string,
  allSelectedKPIsInfo: PropTypes.shape({}),
  crosstabWeightTypes: PropTypes.shape({}),
  standardBaseLists: PropTypes.shape([]),
  toggleCheckVal: PropTypes.shape({}),
  handleSaveCrosstab: PropTypes.func,
  trackerFn: PropTypes.func,
  crosstabFootNotes: PropTypes.shape({}),
  handleCrosstabEdit: PropTypes.func,
  crosstabRequestData: PropTypes.shape({}),
  editExpression: PropTypes.bool,
  partsToShow: PropTypes.shape({}),
  handleProbabilitiesEditClick: PropTypes.func,
  crosstabPayload: PropTypes.arrayOf(PropTypes.shape({})),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    partsToShow: state.crosstab.partsToShow,
    crosstabTableList: state.crosstab.crosstabTableList,
    crosstabStudy: state.study.crosstabStudy,
    trendStudies: state.study.trendStudies,
    crosstabColumns: state.crosstab.ColumnsDataGridData,
    crosstabRows: state.crosstab.RowsDataGridData,
    allSelectedKPIsInfo: state.crosstab.allSelectedKPIsInfo,
    loadedCrosstabInfo: state.crosstab.loadedCrosstabInfo,
    crosstabWeightTypes: state.study.crosstabWeightTypes,
    selectedBase: state.selectedBase,
    standardBaseLists: state.crosstab.standardBaseLists,
    toggleCheckVal: state.crosstab.toggleCheckValue,
    crosstabRequestData: state.crosstab.crosstabRequestData,
    crosstabPayload: state.crosstab.crosstabPayload,
    crosstabFootNotes: state.study.crosstabFootNotes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(React.memo(CrosstabViewer));
